import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

import * as VS from '@core/models/version-share.model';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

import { ThreeDotMenuElement } from '@core/classes/three-dot-menu-item.class';

import { ThreeDotService } from '@core/services/three-dot/three-dot.service'
import { Subscription } from 'rxjs';

@Component({
    selector: 'core-version-shares-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class CoreVersionSharesItemComponent implements OnInit, OnDestroy {
    
    @Input() shareItem: VS.VersionShare;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    @Output() menuClick = new EventEmitter<VS.VersionShareListItemMenuClick>();

    public readonly APPROVAL_STATUS_COLORS = VS.ApprovalStatusColorValues; //['#F6B273','#47B934','#F44848'];
    public readonly FEEDBACK_STATUS_COLORS = VS.FeedbackStatusColorValues;
    public readonly UPLOAD_VERSION_STATUS_COLORS = VS.UploadVersionStatusColorValues;

    //1-> Approved: 47B934 (old'#92D77D',)
    //2-> Rejected: F44848   (old'#C8494E', )
    //3-> only comments: '#C8494E', ????
    public menuElement: ThreeDotMenuElement;
    
    public triggered: boolean;
    protected subscription: Subscription;
    constructor(
        private vsSrv: VersionSharesService,
        private dotSrv: ThreeDotService
    ){}

    ngOnInit(): void {
        // create a new Menu Element to get its id..
        this.menuElement = new ThreeDotMenuElement(this.menu);
        // filter the real items in menu to quit reset on non Resettable Items (the ones pending yet)
        if(this.shareItem.type == VS.VersionShareType.UPLOAD_VERSION_TYPE 
            || (this.shareItem.type == VS.VersionShareType.FEEDBACK_TYPE && this.shareItem.status.status_code ==  VS.FeedbackStatusCodeEnum.OPENED_CODE )
            || (this.shareItem.type == VS.VersionShareType.APPROVAL_TYPE && this.shareItem.status.status_code == VS.ApprovalStatusCodeEnum.PENDING_CODE)
        ){
            this.menu = this.menu.filter((i: ThreeDotsMenuItem) => "reset-share" != i.key);
        } else {
            this.menu = this.menu
        }

        // get the active status of this menu
        this.subscription = this.dotSrv.getTriggerObservable(this.menuElement.id).subscribe((active: boolean) => {
            this.triggered = active;
        });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getShareStatusText(share: VS.VersionShare) : string {
        switch (share.type) {
            case VS.VersionShareType.UPLOAD_VERSION_TYPE:
                return "New Version";
                break;
            case VS.VersionShareType.FEEDBACK_TYPE:
                return 'Comments';
                break;
            case VS.VersionShareType.APPROVAL_TYPE:
                return share.status.status_text;
                break;
            default:
                return  "Pending";
                break;
        }
    }

    // updated dec-2023 and ready to get all kind shares bubbles <diego@twonas.com>
    public getShareBubbleColor(share: VS.VersionShare) {
        return this.vsSrv.getVersionShareBubbleColor(share);
    }

    onActionMenuClick(itemKey: string){
        const shareMenuItem: VS.VersionShareListItemMenuClick = {key: itemKey, share: this.shareItem, menuIdentifier: this.menuElement.id };
        this.dotSrv.setTriggered(this.menuElement.id, true); // trigger the 3dotMenuService
        this.menuClick.emit(shareMenuItem);
    }


}
